import { render, staticRenderFns } from "./CRProject.vue?vue&type=template&id=66e5970a&scoped=true"
import script from "./CRProject.vue?vue&type=script&lang=js"
export * from "./CRProject.vue?vue&type=script&lang=js"
import style0 from "./CRProject.vue?vue&type=style&index=0&id=66e5970a&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5970a",
  null
  
)

export default component.exports